export default __webpack_public_path__ + "static/media/ya.c760d9d4.png";